import { Grid, Box, Paper, Input, Button, Alert } from '@prometheus/components';
import { userSignIn } from '@prometheus/redux';
import { useTranslation } from 'react-i18next';
import React from 'react';
import { useDispatch } from 'react-redux';
import { LogoLarge } from '../Logo/LogoLarge';
import {
  FormControl,
  LoginFormContainer,
  LoginFormHeader,
  LogoContainer,
  WelcomeText,
} from './LoginPage.styles';

export const LoginPage: React.FC<{ hasError: boolean }> = ({ hasError }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [userName, setUserName] = React.useState<string>('');
  const [password, setPassword] = React.useState<string>('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    dispatch(userSignIn(userName, password));
  };

  return (
    <Grid container height="100vh">
      <LogoContainer
        item
        container
        xs={0}
        md={6}
        sx={{ display: { xs: 'none', md: 'flex' } }}
      >
        <Grid item xs={5} mx="auto" my="auto">
          <LogoLarge color="white" />
        </Grid>
      </LogoContainer>
      <LoginFormContainer item container xs={12} md={6}>
        <Box minWidth={450} width="50%" mx="auto">
          <form onSubmit={handleSubmit}>
            <Paper>
              {hasError && (
                <Alert severity="error">
                  {t('messages.validation_text_login')}
                </Alert>
              )}

              <Grid container p={4} spacing={3}>
                <Grid item xs={12} spacing={2} container>
                  <WelcomeText item xs={12}>
                    {t('modules.layout.login.welcome_text', {
                      app: 'Prometheus Data Node',
                    })}
                  </WelcomeText>
                  <LoginFormHeader item xs={12}>
                    {t('modules.layout.login.login_header')}
                  </LoginFormHeader>
                </Grid>

                <Grid item xs={12} spacing={2} container>
                  <FormControl item xs={12}>
                    <label>{t('forms.username')}</label>
                    <Input
                      fullWidth
                      value={userName}
                      onChange={e => setUserName(e.target.value)}
                      placeholder={t('forms.username_placeholder')}
                    />
                  </FormControl>
                  <FormControl item xs={12}>
                    <label>{t('forms.password')}</label>
                    <Input
                      fullWidth
                      type="password"
                      value={password}
                      onChange={e => setPassword(e.target.value)}
                      placeholder={t('forms.password_placeholder')}
                    />
                  </FormControl>
                  <Grid item xs={12} textAlign="right">
                    <Button
                      variant="contained"
                      color="success"
                      type="submit"
                      fullWidth
                    >
                      {t('buttons.login')}
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
            </Paper>
          </form>
        </Box>
      </LoginFormContainer>
    </Grid>
  );
};
